@if (projectMatchesArray && projectMatchesArray.length === 0) {
  <div>
    <strong>Unfortunately, there aren't any projects that match your reading profile - Please adjust your reading profile, or check back soon!</strong>
  </div>
}
@if (projectMatchesArray && projectMatchesArray.length > 0) {
  <div>
    <p-dataView #dv [value]="dataService.rMatchSignal()" [paginator]="true" [rows]="9" filterBy="title" [sortField]="sortField" [sortOrder]="sortOrder">
      <ng-template #header>
        <div class="flex flex-column md:flex-row md:justify-between gap-2">
          <p-select [options]="sortOptions" placeholder="Best Match" (onChange)="onSortChange($event)" />
          <span class="p-input-icon-left">
            <i class="pi pi-search"></i>
            <input type="search" pInputText placeholder="Search by Title" (input)="onFilter(dv, $event)">
          </span>
        </div>
      </ng-template>
      <ng-template let-pm #list>
        @for (projectMatch of pm; track projectMatch) {
          <div class="col-span-12">
            <project-display [projectMatch]="projectMatch" [projectDisplayMode]="ProjectDescriptorUse.BETA_READER_VIEW_OF_PROJECT" />
          </div>
        }
      </ng-template>
    </p-dataView>
  </div>
}
